import { notify } from "@/services/notification"

export default class Attestation {
  constructor(data) {
    this.id = data.id
    this.date = data.date
    this.student_course_id = data.student_course_id
    this.created_at = data.created_at
    this.updated_at = data.updated_at
    this.type = data.type
    this.objective_achieved = data.objective_achieved

    this.comment = data.comment
    this.work_organisation = data.work_organisation
    this.group_integration = data.group_integration
    this.motivation = data.motivation
    this.home_study = data.home_study

    this.oral_production = data.oral_production
    this.writing_production = data.writing_production
    this.reading = data.reading
    this.numbers = data.numbers
    this.dictation = data.dictation
    this.lang_structure = data.lang_structure
    this.oral_comprehension = data.oral_comprehension
    this.writing_comprehension = data.writing_comprehension

    this.job_search_offers = data.job_search_offers
    this.job_modify_dossier = data.job_modify_dossier
    this.job_interview_participation = data.job_interview_participation
    this.information_domain = data.information_domain
    this.have_formation_project = data.have_formation_project
    this.self_awareness = data.self_awareness
    this.mini_plan = data.mini_plan
    this.know_swiss_formation = data.know_swiss_formation
    this.asked_for_internship = data.asked_for_internship
    this.have_dossier_paper = data.have_dossier_paper
    this.have_dossier_digital = data.have_dossier_digital
    this.post_apprentissage = data.post_apprentissage

    this.it_use_devices = data.it_use_devices
    this.it_use_internet = data.it_use_internet
    this.it_communication_tic = data.it_communication_tic
    this.it_security_online = data.it_security_online
    this.it_use_online_services = data.it_use_online_services

    this.course_type = data.course_type
    this.next_level = data.next_level
  }

  get typeTranslated() {
    return this.type === "final" ? "final" : "intermédiaire"
  }

  get isLanguageCourse() {
    return this.course_type === "fr" || this.course_type === "frdistance" || this.course_type === "re" || this.course_type === "cp"
  }

  get isJobCourse() {
    return this.course_type == "re"
  }

  get isItCourse() {
    return this.course_type == "it"
  }

  /**
   * Tests performed during the course
   */
  get specificFields() {
    let fields = []
    if (this.isLanguageCourse) {
      // no specific fields
    }
    if (this.isJobCourse) {
      fields = fields.concat(re_course_fields)
    }
    if (this.isItCourse) {
      fields = fields.concat(it_course_fields)
    }
    return fields
  }

  // API
  static async getAll() {
    return await axios.get(`/api/v1/attestations`, { dataKey: "data" }).catch((error) => {
      notify("error", error)
      return error
    })
  }

  static async getAttestationsByStudentCourseId(studentCourseId) {
    const result = await axios.get(`/api/v1/attestations/student-course/${studentCourseId}`).catch((error) => {
      notify("error", error)
      return error
    })
    return result?.data.data.map((attestation) => new Attestation(attestation))
  }

  static async upsertAttestation(attestation) {
    return axios
      .post(`/api/v1/attestations/upsert`, attestation)
      .then(() => {
        notify("success", "Réussi")
      })
      .catch((error) => {
        notify("error", error.response.data.message)
      })
  }

  static async deleteAttestation(attestationId) {
    return axios
      .delete(`/api/v1/attestations/${attestationId}`)
      .then(() => {
        notify("success", "Attestation supprimée avec succès")
      })
      .catch((error) => {
        notify("error", error.response?.data?.message || "Erreur lors de la suppression")
      })
  }
}

// Constants
const re_course_fields = [
  {
    field: "job_search_offers",
    description: "Chercher et comprendre des offres",
  },
  {
    field: "job_modify_dossier",
    description: "Modifier mon dossier de candidature (CV, lettre de motivation)",
  },
  {
    field: "job_interview_participation",
    description: "Participer à un entretien d’embauche",
  },
  {
    field: "information_domain",
    description: "M’informer sur les formations et les métiers de mon domaine",
  },
  {
    field: "have_formation_project",
    description: "Avoir un projet de formation réaliste",
  },
  {
    field: "self_awareness",
    description: "Connaître ses atouts, ses qualités, ses points faibles",
  },
  { field: "mini_plan", description: "Faire un mini-bilan de mes compétences" },
  {
    field: "know_swiss_formation",
    description: "Connaître le système de formation suisse",
  },
  { field: "asked_for_internship", description: "Faire une demande de stage" },
  {
    field: "have_dossier_paper",
    description: "Avoir un dossier de candidature papier",
  },
  {
    field: "have_dossier_digital",
    description: "Avoir un dossier de candidature digital",
  },
  {
    field: "post_apprentissage",
    description: "Postuler pour un apprentissage ou une formation de façon autonome",
  },
  {
    field: "post_work",
    description: "Postuler pour un apprentissage ou un emploi de façon autonome",
  },
]

const it_course_fields = [
  {
    field: "it_use_devices",
    description: "Utiliser des appareils à commande numérique",
  },
  { field: "it_use_internet", description: "Utiliser Internet" },
  { field: "it_communication_tic", description: "Communiquer grâce aux TIC" },
  {
    field: "it_security_online",
    description: "Assurer sa propre sécurité lors de l’utilisation des TIC",
  },
  {
    field: "it_use_online_services",
    description: "Utiliser des prestations en ligne",
  },
]
